import { query } from 'src/utils/request';

// 添加银行卡信息
export const addBankCardInfo = async data => {
  return query('/zlb/api/pay/bankCard/addOrgAccount', {
    data,
    method: 'post',
  });
};

// 编辑银行卡信息
export const editBankCardInfo = async data => {
  return query('/zlb/api/pay/bankCard/edit', {
    data,
    method: 'post',
  });
};

export const requestBankCardList = async data => {
  return query('/zlb/api/pay/bankCard/org/list', {
    method: 'POST',
    data,
  });
};
// 查询账户关联的会计科目
export const requesAccountSubjectCardList = async data => {
  return query('/zlb/budget/account/subject/list-account-subject', {
    method: 'POST',
    data,
  });
};
// 删除银行卡信息
export const deleteBankCard = async code => {
  return query(`/zlb/api/pay/bankCard/delete/${code}`, {
    method: 'post',
  });
};

// 单位账户类型校验
export const checkOrgBankCard = async data => {
  return query('/zlb/api/pay/bankCard/org/check', {
    method: 'post',
    data,
  });
};

// 托收账户更换
export const transferCollectionAccount = async data => {
  return query('/zlb/api/pay/bankCard/transferTuoshouAccount', {
    method: 'post',
    data,
  });
};
